/**
 * Selection Controls Showcase Page
 *
 * Demonstrates selection control widgets:
 * - Checkboxes
 * - Radio buttons
 * - Switches
 * - Multiple select
 *
 * Route: /apps/examples/forms/selection-controls-showcase
 * API: /v2/api/formsexamples/rul/forms/selection_controls_showcase
 */

import { message } from 'antd';
import { UniversalRULForm } from '@/components/features/rul/UniversalRULForm';
import './SelectionControlsShowcasePage.css';

export const SelectionControlsShowcasePage: React.FC = () => {
  const handleSuccess = (data: any) => {
    message.success('Form validated successfully!');
    console.log('Form submitted:', data);
  };

  const handleError = (errors: Record<string, string>) => {
    message.error('Please fix validation errors');
    console.error('Validation errors:', errors);
  };

  return (
    <div className="selection-controls-showcase-page">
      <div className="selection-controls-showcase-container">
        <UniversalRULForm
          formUrl="/formsexamples/rul/forms/selection_controls_showcase"
          onSuccess={handleSuccess}
          onError={handleError}
          className="selection-controls-showcase-form"
          debounceMs={500}
        />
      </div>
    </div>
  );
};
